import { render, staticRenderFns } from "./VueRecaptchaWrapper.vue?vue&type=template&id=1213e838&"
import script from "./VueRecaptchaWrapper.vue?vue&type=script&lang=ts&"
export * from "./VueRecaptchaWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports